import $ from 'jquery'
import { initSlides } from '../abstracts/utils'

export default () => {
  $(() => {
    if (!$('body').hasClass('archive') || !$('body').hasClass('post-type-archive-project')) return

    let $sectionProjectTypes = $('.section-project-types')
    $sectionProjectTypes.each((index, item) => {
      initSlides($(item).find('.slideshow:not(.slick-initialized.slick-slider)'), 3, true, false, [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
      ])
    })
  })
}
